export class Bundle {
  cost: number = 0;
  deletedAt?: Date;
  maxImages: number = 0;
  deployments: number = 0;
  trainingCost: number = 0;
  inferenceCost: number = 0;
  cloningRoyalty: number = 0;
  privateDatasets: number = 0;
  privateProjects: number = 0;
  isActive: boolean = true;
  name: string | null = null;
  createdAt: Date | null = null;
  updatedAt: Date | null = null;
  canAccessApis: boolean = false;
  canCloneProject: boolean = false;
  canCloneDataset: boolean = false;
  isSystemCreated: boolean = false;
  modelDownloadCost: number = 0;
  activeLearningCost: number = 0;
  smartAnnotationsCost: number = 0;
  allowsCollaborators: boolean = false;
  allowsModelVersioning: boolean = false;
  allowsCustomTrainingConfig: boolean = false;

  constructor(values?: any) {
    if (values && Object.keys(values)?.length) {
      Object.assign(this, values);
    }
  }
}

export class UserBundle {
  deletedAt?: Date;
  active: boolean = false;
  id: number | null = null;
  userId: number | null = null;
  bundle: any | null = null;
  createdAt: Date | null = null;
  updatedAt: Date | null = null;
  bundleId: number | null = null;
  isLimitExceeded: boolean = false;
  nextBillingDate: Date | null = null;
  bundlePurchaseDate: Date | null = null;

  constructor(values?: any) {
    if (values && Object.keys(values)?.length) {
      Object.assign(this, values);
      if (values.bundle?.id) {
        this.bundle = new Bundle(values.bundle);
      }
    }
  }
}

export class UserStats {
  uploadedImagesCount: number = 0;
  privateDatasetsCount: number = 0;
  privateProjectsCount: number = 0;

  constructor(values?: any) {
    if (values && Object.keys(values)?.length) {
      Object.assign(this, values);
    }
  }
}
